import { render, staticRenderFns } from "./paymentProtocolSetting.vue?vue&type=template&id=9016503e&"
import script from "./paymentProtocolSetting.vue?vue&type=script&lang=js&"
export * from "./paymentProtocolSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports